'use client';

import React, { FC } from 'react';
import styled from 'styled-components';

import background from '../../public/paymentProcessingBg.webp';

import { Container } from '@/components/Container';
import { backgroundImageMixin } from '@/styles/BackgroundimageMixin';
import { devices } from '@/styles/breakpoints';
import { TitleH2 } from '@/styles/typography';

interface IProps {}

export const PaymentProcessingIntro: FC<IProps> = () => {
  return (
    <SectionWrapper>
      <Overlay>
        <Container>
          <WrapperInner>
            <LabelWrapper>
              <h1>Payment Processing</h1>
            </LabelWrapper>

            <Title>
              <span className="first_part">
                Increase your profits with <br /> flexible{' '}
              </span>
              <span className="second_part"> payment processing</span>
            </Title>

            <Description>
              Payment processing can be very complicated in any business.
              Orcatec is happy to help you to navigate this difficult path and
              able to provide the best payment structure and rates, starting
              from just a 2.05% transaction fee, by working with Clover Connect
              as our payment partner
            </Description>
          </WrapperInner>
        </Container>
      </Overlay>
    </SectionWrapper>
  );
};

const SectionWrapper = styled.section`
  position: relative;
  width: 100%;
  height: 608px;
  ${backgroundImageMixin(background.src)};

  @media only screen and ${devices.desktop} {
    height: 768px;
  }
`;

const LabelWrapper = styled.div`
  color: var(--fontColorDarkBlue);
  text-align: left;
  font-family: var(--font-roboto);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 8px;
  @media only screen and ${devices.desktop} {
    text-align: center;
  }
`;

const Overlay = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const WrapperInner = styled.article`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  margin: 0 auto;
  padding-top: 30px;
  & button {
    width: 100% !important;
  }
  @media only screen and ${devices.desktop} {
    padding-top: 62px;
    align-items: center;
    max-width: 720px;
    & button {
      width: 165px !important;
      padding: 12px 24px;
    }
  }
`;

const Title = styled(TitleH2)`
  text-align: left;
  margin-bottom: 16px;
  font-size: 32px;
  & .first_part {
    color: var(--darkBlueText);
  }
  & .second_part {
    color: var(--mainBlue);
  }

  @media only screen and ${devices.desktop} {
    line-height: 46px;
    text-align: center;
    margin-bottom: 24px;
    font-size: 48px;
    line-height: 58px;
  }
`;

const Description = styled.p`
  font-family: var(--font-roboto);
  color: var(--fontColorDarkGrey);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 32px;
  @media only screen and ${devices.desktop} {
    text-align: center;
  }
`;
